module.exports = "uniform highp vec4 uColor;\r\n\r\nvoid main(void) {\r\n  gl_FragColor = uColor;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/simple-gl/rect.f.glsl
// module id = 8
// module chunks = 0